export default __webpack_public_path__ + "static/media/arrow-right-white.305bda36.svg";